import {
  GetWorkUnsynced,
  WorkSyncStatusEnum,
} from '@mzic/mzic-interfaces';

export const worksUnsyncedMockData: GetWorkUnsynced = {
  timestamp: new Date('2025-10-05T10:00:00Z'),
  status: 'success',
  data: {
    content: [
      {
        id: 1,
        title: 'Midnights',
        composerNames: 'Taylor Swift',
        ecadCode: '9312313',
        iswc: 'T-123.33.888',
        status: WorkSyncStatusEnum.MODIFIED,
      },
      {
        id: 2,
        title: 'Lover',
        composerNames: 'Taylor Swift',
        ecadCode: '9312313',
        iswc: 'T-123.33.888',
        status: WorkSyncStatusEnum.NEW,
      },
      {
        id: 3,
        title: 'Anti-Hero',
        composerNames: 'Taylor Swift x Jack Antonoff',
        ecadCode: '9312313',
        iswc: 'T-123.33.888',
        status: WorkSyncStatusEnum.PUBLIC_DOMAIN,
      },
      {
        id: 4,
        title: 'Blinding Lights',
        composerNames: 'The Weeknd x Max Martin',
        ecadCode: '8765432',
        iswc: 'T-987.65.432',
        status: WorkSyncStatusEnum.MODIFIED,
      },
      {
        id: 5,
        title: 'As It Was',
        composerNames: 'Harry Styles x Tyler Johnson',
        ecadCode: '7654321',
        iswc: 'T-765.43.210',
        status: WorkSyncStatusEnum.NEW,
      },
    ],
    totalPages: 1,
    totalElements: 5,
    last: true,
    size: 10,
    number: 0,
    numberOfElements: 5,
    first: true,
    empty: false,
    sort: {
      empty: true,
      sorted: false,
      unsorted: true,
    },
    pageable: {
      offset: 0,
      sort: {
        empty: true,
        sorted: false,
        unsorted: true,
      },
      pageNumber: 0,
      pageSize: 10,
      paged: true,
      unpaged: false,
    },
  } as any,
  error: {
    error: '',
    title: '',
    code: '',
    trace: '',
    modal: false,
  },
  errors: [
    {
      error: '',
      title: '',
      code: '',
      trace: '',
      modal: false,
    },
  ],
  page: 0,
  metadata: {
    additionalProp1: {},
    additionalProp2: {},
    additionalProp3: {},
  },
  total_pages: 1,
  per_page: 10,
  total_items: 5,
} as any;
